module.exports = __webpack_public_path__ + "static/media/banner2.30e94e97.jpg";